import React from "react";
import {
  StyledSupport,
  Header,
  Link,
  BoldText,
  SubText,
  SupportBox,
  People,
  TextColumn,
  Text,
  ButtonBox,
  StandIn,
  TacaLogo,
} from "./styles";

import { Button } from "../Button/Button";
export const Support = ({ supportAni }) => (
  <StyledSupport id="taca">
    <Header>
      <BoldText>Give Love By Showing Support to TACA</BoldText>
      <SubText>
        TACA provides education, support and hope to families living with
        developmental disabilities.
      </SubText>
      <SubText>
        To find out more{" "}
        <Link target="_blank" href="https://tacanow.org">
          www.tacanow.org
        </Link>
      </SubText>
    </Header>
    {supportAni ? (
      <SupportBox supportAni={supportAni}>
        <People src="https://resources.swmc.com/images/yourtruehome/SunWest-people.png" />
        <TextColumn>
          <TacaLogo></TacaLogo>
          <Text>
            TACA’s vision is for every individual diagnosed with developmental
            disabilities to lead an independent life. Our family programs
            include: education, support, family events, mentorship, resources,
            conference, chapters, scholarships, and more. Sun West Mortgage
            Company, Inc. is a proud sponsor of TACA.
          </Text>
          <ButtonBox>
            {/* YTH-23 updating link redirection to AutismHeroes landing page */}
            <Button
              link="https://www.swmc.com/autismheroes"
              text="Visit Our Website"
            />
          </ButtonBox>
        </TextColumn>
      </SupportBox>
    ) : (
      <StandIn>
        <SupportBox supportAni={supportAni}>
          <People src="https://resources.swmc.com/images/yourtruehome/SunWest-people.png" />
          <TextColumn>
            {/* <TacaLogo></TacaLogo> */}
            <Text>
              TACA’s vision is for every individual diagnosed with autism to
              lead an independent life. Our family programs include: education,
              support, family events, mentorship, resources, conference,
              chapters, scholarships, and more. Sun West Mortgage Company, Inc.
              is a proud sponsor of TACA.
            </Text>
            <ButtonBox>
              <Button
                link="http://autismheroes.swmc.com/"
                text="Visit Our Website"
              />
            </ButtonBox>
          </TextColumn>
        </SupportBox>
      </StandIn>
    )}
  </StyledSupport>
);
